export default {
  id: 179,
  title: 'Target #179 - Tanzania',
  url: 'https://cssbattle.dev/play/179',
  colors: ['#14A84A', '#F8CD1E', '#000000', '#3B66B0'],
  solution:
    '<style>body{background:linear-gradient(-30deg,#3b66b0 160px,#f8cd1e 160px 180px,#000 180px 280px,#f8cd1e 280px 300px,#14a84a 300px)}</style>',
}
